import {
  Contact2Icon,
  DollarSign,
  LocateIcon,
  MessageCircleIcon,
  PencilIcon,
  PhoneCallIcon,
  TrashIcon,
} from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import { Job } from "types/booking.interface";
import { formatCurrency, nairaSymbol, truncateWords } from "utills/helper";

interface Props {
  job: Job;
  showBtn?: boolean;
}
export function JobCard({ job }: Props) {
  const nav = useNavigate();

  const handleEditJob = (e: any, id: string) => {
    e.stopPropagation();

    nav(`/edit-job?jobId=${id}`);
  };

  const handleView = (id: string) => {
    nav(`/job-details?jobId=${id}`);
  };

  return (
    <div
      onClick={() => handleView(job?._id!)}
      className=" flex flex-wrap gap-4 mt-3 bg-white p-2 shadow-md cursor-pointer"
    >
      <div>
        <img
          src={job?.coverPhoto?.url}
          className=" w-[150px] h-[110px] rounded-md object-cover"
        />
      </div>

      <div className="flex flex-col gap-3 w-full">
        <div className="flex items-center justify-between  w-full ">
          <p className=" text-custom-500">{job?.title}</p>

          <div className="flex items-center gap-4 ">
            <button
              onClick={(e) => handleEditJob(e, job._id!)}
              className="flex items-center gap-3 text-sm text-blue-600"
            >
              <span>Edit</span>
            </button>
            {/* <button className="flex items-center gap-3 text-sm text-red-500">
              <span>Delete</span>
            </button> */}
          </div>
        </div>

        <div className="flex min-w-0 items-center gap-2 text-gray-400">
          <PhoneCallIcon />
          <span>{job?.owner?.phoneNumber},</span>
        </div>
        <div className="flex min-w-0 items-center gap-2 text-gray-400">
          <MessageCircleIcon />
          <a className="break-all" href={`mailto:${job?.owner?.email}`}>{job?.owner?.email},</a>
        </div>

        <div className=" flex flex-wrap items-center gap-x-8 gap-y-1">
          <div className="flex min-w-0 items-center gap-2 text-gray-400">
            <LocateIcon />
            <span>
              {job?.area}, {job?.location}
            </span>
          </div>
          <div className="flex min-w-0 items-center gap-2 text-gray-400">
            {nairaSymbol}
            {formatCurrency(job?.minSalary || 0)} - {nairaSymbol}
            {formatCurrency(job?.maxSalary || 0)}
          </div>
        </div>

        <div className="flex min-w-0 items-center gap-2 text-gray-400">
          <Contact2Icon />
          <span>Posted: {new Date(job?.createdAt!).toDateString()}</span>
        </div>
      </div>
    </div>
  );
}
